import React from 'react';
import { translate } from '../../../Services/translation';
import clsx from 'clsx';
import Icon from '../../Icon';

const OrderListItemDesktop = ({ order, onClick, onClickApprove }) => {
  return (
    <li
      className={clsx(
        'grid',
        'grid-cols-6',
        'p-2',
        'gap-4',
        'border',
        'border-solid',
        'border-gray-300',
        '[&:nth-child(even)]:bg-gray-100',
        '[&:nth-child(odd)]:bg-white',
        '[&:last-child]:border-b-0'
      )}
    >
      <span className={clsx('text-sm')}>{order.externalOrderID}</span>
      <span className={clsx('text-sm')}>{order.orderRows.length}</span>
      <span className={clsx('text-sm')}>{order.orderDate}</span>
      <span className={clsx('text-sm')}>{order.orderGrandTotal}</span>
      <a
        className={clsx(
          'text-sm',
          'text-primary-500',
          'cursor-pointer',
          'underline',
          'text-right'
        )}
        onClick={() => onClick && onClick(order)}
      >
        {translate('orderlist.column.readmore')}
      </a>
      <a
        className={clsx(
          'text-sm',
          'text-primary-500',
          'cursor-pointer',
          'underline',
          'text-right'
        )}
        onClick={() => onClickApprove && onClickApprove(order)}
      >
        <Icon
          name="check"
          className="color-alert"
          style={{
            color: 'green',
            width: '26px',
            height: '26px',
          }}
        />
      </a>
    </li>
  );
};

export default OrderListItemDesktop;
